import { createSelector } from 'reselect'
import user_logged_selector from 'redux/selectors/user_extra_data/user_logged_selector'
import filterTabs from 'helpers/enums/filters/tabs'
import { findItemInCategory } from 'helpers/filter/findInCategory'
import viewTypes from 'helpers/enums/viewTypes'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const getLessons = state => state.lessons
const getStore = state => state.store
const getUI = state => state.ui
const getQs = state => state.qs
const getUserExtra = state => state.user.extra

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.PAYWALLS_PROJECT,
])

const storeSelector = createSelector(
	[ getLessons, getStore, getUI, getQs, getUserExtra, user_logged_selector, featureFlagsSelector ],
	(lessonsData, storeData, uiData, qsData, userExtraData, isUserLogged, featureFlags) => {

		let lessons = storeData.results
			.map(entityUID => lessonsData[entityUID])

		if (storeData.currentTab === filterTabs.STANDARDS_TAB && qsData.filters) {
			const strandId = qsData.filters.find(entityUID => findItemInCategory(storeData.standard[0], entityUID))
			lessons = lessons.map(lesson => ({
				...lesson,
				data: {
					...lesson.data,
					strandId,
				},
			}))
		}

		const shouldHidePrice = featureFlags[featureFlagsTypes.PAYWALLS_PROJECT]

		return {
			filters: storeData.standard,
			lessons,
			useGridPadding: !(uiData.currentView && (uiData.currentView === viewTypes.STORE_SEARCH)),
			showPriceThumb: !shouldHidePrice && !(userExtraData && userExtraData.hasPremiumAyce),
		}
	}
)

export default storeSelector
